export const scope = 'offline_access files.readwrite.all 	';
export const client_id = 'f981fe9c-519c-4b30-b57e-6a23c046f218';
export const redirect_uri = 'http://localhost/';